import '../applicant-info.scss';
import {useIntl} from "react-intl";
import {Modal} from "react-bootstrap";
import {Field} from 'formik';
import toast from 'react-hot-toast';
import {WLOCreditAPIService} from '../../../../services';
import * as _ from 'lodash';
import {typeIdentification} from '../../../../__mocks__/data';
import {useRequestContext} from '../../../../hooks/useRequestContext';
import {useLoginContext} from '../../../../hooks/useLoginContext';

interface FormSpouseProps {
    show: boolean;
    onHide: () => void;
    errors?: any;
    values?: any;
}

export function FormSpouse(props: FormSpouseProps) {
    const {user} = useLoginContext();
    const {request, setRequest} = useRequestContext();

    const {show, onHide, errors, values} = props;
    const intl = useIntl();
    const handleSaveConyugue = async (e: any) => {
        e.preventDefault();
        if (!_.isEmpty(values.Pws_Con_Tip_identif!) || !_.isEmpty(values.Pws_Con_nomsol!) || !_.isEmpty(values.Pws_Con_identif!) || !_.isEmpty(values.Pws_Con_tel!)) {
            if (values.Pws_Estado_Civil === "1" || values.Pws_Estado_Civil === "3") {
                const conyugue = {
                    Pws_Num_solicitud: request.numSol!,
                    Pws_Identificacion: values.Pws_Identificacion,
                    Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
                    Pws_Con_Tip_identif: values.Pws_Con_Tip_identif,
                    Pws_Con_nomsol: values.Pws_Con_nomsol,
                    Pws_Con_identif: values.Pws_Con_identif,
                    Pws_Con_tel: values.Pws_Con_tel,
                }
                const result = await WLOCreditAPIService.addConyugue(conyugue)
                if (result.payload.result === "1") {
                    toast.success('Se ha guardado de manera exitosa');
                    onHide();
                }
            } else {
                toast.error('Debe seleccionar una opción del combo Estado Civil');
            }
        }
    }
    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-center"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="title-modal-spouse">
                        {intl.formatMessage({id: "spouse_data"})}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={'row'}>
                    <div className="row">
                        <div className="col">
                            <div
                                className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "full_name_spouse"})}</div>
                            <Field id={"Pws_Con_nomsol"}
                                   name={"Pws_Con_nomsol"}
                                   className={`${errors.Pws_Con_nomsol ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                                   placeholder={intl.formatMessage({id: "enter"})}/></div>
                        <div className="col">
                            <div
                                className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_identification_type"})}</div>
                            <Field as="select"
                                   id={"Pws_Con_Tip_identif"}
                                   name={"Pws_Con_Tip_identif"}
                                   className={`${errors.Pws_Con_nomsol ? 'form-know-you-item-input-xxs display-flex input-error' : 'form-know-you-item-input-xxs display-flex'}`}>
                                <option>{intl.formatMessage({id: "enter"})}</option>
                                {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.map((item, key: number) => {
                                    return (
                                        <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                                    )
                                })}
                            </Field>

                        </div>
                        <div className="col">
                            <div
                                className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "identification_spouse"})}</div>
                            <Field id={"Pws_Con_identif"}
                                   name={"Pws_Con_identif"}
                                   type={"number"}
                                   className={`${errors.Pws_Con_identif ? 'form-know-you-item-input-xs display-flex input-error' : 'form-know-you-item-input-xs display-flex'}`}
                                   placeholder={intl.formatMessage({id: "enter"})}/></div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div
                                className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_phone_1"})}</div>
                            <Field id={"Pws_Con_tel"}
                                   name={"Pws_Con_tel"}
                                   type={"number"}
                                   className={`${errors.Pws_Con_tel ? 'form-know-you-item-input-xs display-flex input-error' : 'form-know-you-item-input-xs display-flex'}`}
                                   placeholder={intl.formatMessage({id: "placeholder_phone_1"})}/>
                            <br/>

                        </div>
                        <div className="col"/>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={"form-know-you-item-button"} onClick={props.onHide}>
                                {intl.formatMessage({id: "button_cancel"})}
                            </div>
                        </div>
                        <div className="col">

                        </div>
                        <div className="col">
                            <div className={"form-know-you-item-button-gray"} onClick={handleSaveConyugue}>
                                {intl.formatMessage({id: "button_continue"})}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}